import { render, staticRenderFns } from "./SmsOptions.vue?vue&type=template&id=1bc695c2&"
import script from "./SmsOptions.vue?vue&type=script&lang=ts&"
export * from "./SmsOptions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports